export default __webpack_public_path__ + "static/media/img-0792-greece-full-face.d202f8b7.png";